<template>
    <a-modal
    :visible="visible"
    :title="$t('page_andon_call_synchronization_settings')"
    @cancel="cancel()"
    @ok="handleOk"
    :okText="$t('page_sync')"
    width="800px"
    >
      <a-tree
        v-model="checkedKeys"
        checkable
        :checkedKeys="checkedKeys"
        :expandedKeys="expendKeys"
        :tree-data="tree"
        @expand="expandKey"
        @check="onSelect"
      >
      </a-tree>
    </a-modal>
</template>

<script>
import Vue from 'vue'
import { DeviceStandardSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const deviceStandardSettingServiceProxy = new DeviceStandardSettingServiceProxy()
export default Vue.extend({
     name: 'CodeModel',
     components: {
    },
    data() {
    return {
      selectedKeys: [],
      checkedKeys: [],
      expendKeys: [],
      workStatoinItems: [],
      tree:[]
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    treeData:{
      type: Array,
      default: () => []
    },
    workStationId: {
      type: String,
      default: ''
    },
    allTree: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.expendKeys = []
        this.checkedKeys = []
      this.tree  = this.treeData
        console.log('tree:', this.tree)
      this.recursion(this.tree)
      }else{
      this.unrecursion(this.tree)
      }
      this.workStatoinItems = []
      this.expendKeys = []
      this.checkedKeys = []
    }
  },
  methods: {
    recursion (val) {
      val.map(item => {
        if (this.workStationId === item.id) {
          item['disabled'] = true
        } else {
          item['disabled'] = false
        }
        if (item.children && item.children.length > 0) {
          this.recursion(item.children)
          if (item.children.length === 1 && item.children[0].id === this.workStationId) {
            item['disabled'] = true
          }
        }
      })
    },
    unrecursion(val) {
      val.map(item =>{
        item.disabled = false
              if(item.children&&item.children.length>0) {
                this.unrecursion(item.children)
              }
      })
    },

    expandKey(value){
      this.expendKeys = value
    },

    onSelect(value){
      this.selectedKeys = value
    },
    getTreeList(){
      this.workStatoinItems = []
      this.expendKeys = []
      this.selectedKeys = []
      wsgsp.workStationGroupList().then(res =>{
        if(res){
          const data = res.reduce((total, value) =>{
            const key = value.id + '-' + value.parentId
            let selectable = false
            if(value.isWorkStation){
              selectable = true
            }
            total.push({
              ...value,
              key: key,
              selectable: selectable
              })
              if(value.isWorkStation && !this.selectedKeys.length){
                this.selectedKeys.push(key)
              } else if(value.isGroup){
                this.expendKeys.push(key)
              }
            return total
          }, [])
          this.treeData = DataTreeNode.arrayToTree(data);
          this.workStatoinItems = data
          this.handelSearch()
        }
      })
    },
    cancel() {
      this.$emit('close')
    },
    handleOk() {
      if (this.checkedKeys.length === 0) {
        this.$message.info('请选择工位！')
        return
      }
      const workstationIds = []
      let arr = [];
      this.checkedKeys.forEach(re => {
        // workstationIds.push(re.split('-')[0])
        arr.push(re.split('-')[0],re.split('-')[1])
      })
      console.log(arr,this.checkedKeys,'全部数据')
      //数据去重
      arr = new Set(arr);
      arr = Array.from(arr);

      //删除为0的元素
      for (var j = arr.length - 1; j >= 0; j--) {
        if(arr[j] == '0') {
            arr.splice(j, 1);
        }
      }

      //删除group为true的值
      for (var t = arr.length - 1; t >= 0; t--) {
        this.allTree.forEach((v) => {
          if(arr[t] == v.id) {
            if(v.isGroup == true) {
              arr.splice(t,1)
            }
          }
        })
      }

      console.log('处理后的数组',arr)
      console.log('checkedKeys', this.checkedKeys)
      deviceStandardSettingServiceProxy.sync(this.workStationId, arr).then(res => {
        this.$message.info('同步成功！')
        this.cancel()
      })
    }
  }
})
</script>
<style lang="less" scoped>
  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0.65)!important;
  }

  /deep/ .anticon {
    color: rgba(0, 0, 0, 0.65)!important;
  }

  /deep/ .ant-modal-body .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg {
    transform: rotate(-90deg)!important;
  }

</style>
